import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { black500 } from '../../../constants/color';
import { useState } from 'react';
import { uploadContainer } from './style';
import { palette } from '../../../../theme/palette';
const theme = palette('light');
export const GenerateContract = ({ text, h = 50, px = 10, py = 0, direction = 'col', borderRadius = '10px', errorBottom = -10, errormsg, onClick // ✅ destructure
 }) => {
    const [file, setFile] = useState(null);
    return (_jsxs(Box, { position: 'relative', height: 'auto', children: [_jsx(Box, { onClick: onClick, sx: {
                    height: `${h}px`,
                    px: `${px}px`,
                    py: `${py}px`,
                    cursor: 'pointer',
                    borderRadius: borderRadius,
                    background: theme.primary.lighter,
                    transition: 'background 0.3s, transform 0.2s',
                    '&:hover': {
                        background: theme.primary.light,
                        transform: 'scale(1.01)'
                    },
                    ...uploadContainer
                }, children: _jsx(Box, { sx: {
                        ...(direction === 'row'
                            ? {
                                display: 'flex',
                                gap: { xs: 2, md: 17 },
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }
                            : {})
                    }, children: _jsx(Typography, { fontSize: '14px', fontWeight: 500, zIndex: 10, color: black500, children: text }) }) }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: file === null ? -19 : errorBottom, left: 5 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, color: '#FF0000', children: errormsg }) }))] }));
};
